import { useEffect } from 'react'

/**
 * Marks a React root's container element as mounted, for tests that need to
 * wait on the React tree rather than on the network.
 *
 * Turbo unmounts and remounts every root around a page change, so `networkidle`
 * and `DOMContentLoaded` both resolve at moments when the container can still
 * be empty: the HTML has arrived and the bundle has booted, but the root for
 * *this* page has not committed yet. A screenshot taken there catches a blank
 * panel. This attribute goes on after the commit and comes off before the next
 * unmount, so waiting for it is the same thing as waiting for the page to be
 * on screen.
 *
 * Rendered as the outermost element of the tree: effects run child-first after
 * commit, so by the time this one fires every descendant is already in the DOM.
 */
export function MountSignal({ target }: { target: HTMLElement }) {
  useEffect(() => {
    target.dataset.mounted = 'true'

    return () => {
      delete target.dataset.mounted
    }
  }, [target])

  return null
}
